import React from "react";
import ExcelJS from "exceljs";
import { parseCustomDate } from "./ExcelVettingReport";
const ExcelSubReport = ({ data }) => {
    const exportExcelFile = async () => {
        if (!Array.isArray(data)) {
            console.error("Data is not an array:", data);
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');
        const formatEditHistory = (history, field, fallbackValue = "") => {
            if ((!Array.isArray(history) || history.length === 0) && fallbackValue) {
                const parts = String(fallbackValue)
                    .split("\n")
                    .map((item) => item.trim())
                    .filter((item) => item.length > 0);
                return parts.map((item, idx) => `${idx + 1}) ${item}`).join("\n");
            }
            if (!Array.isArray(history) || history.length === 0) return "";
            return history
                .map((item, idx) => `${idx + 1}) ${item?.[field] ? item[field] : ""}`)
                .join("\n");
        };

        // Define columns with headers
        worksheet.columns = [
            { header: 'S.No', key: 'serial', width: 10 },
            { header: 'File Name', key: 'file_name', width: 15 },
            { header: 'Loan Type', key: 'loan_type', width: 30 },
            { header: 'LH Branch Name', key: 'lh_branch_name', width: 30 },
            { header: 'Bank Name', key: 'bank_name', width: 40 },
            { header: 'Product Name', key: 'product', width: 30 },
            { header: 'Bank Branch Name', key: 'bank_branch_name', width: 30 },
            { header: 'Borrower Name', key: 'borrower_name', width: 60 },
            { header: 'Owner Name', key: 'owner_name', width: 60 },
            { header: 'App ID', key: 'app_id', width: 40 },
            { header: 'File Status', key: 'file_status', width: 20 },
            { header: 'Mail Initiate Type', key: 'mail_initiate_type', width: 24 },
            { header: 'File Initiation Received Date', key: 'file_initiation_received_dt', width: 26 },
            { header: 'Mail Query Received Date', key: 'mail_query_received_dt', width: 26 },
            { header: 'Login Date', key: 'login_date', width: 20 },
            { header: 'Updated Date', key: 'updated_dt', width: 20 },
            { header: 'Prosses Officer', key: 'prosses_officer', width: 30 },
            { header: 'Verified By', key: 'verified_by', width: 30 },
            { header: 'Double Verified By', key: 'dverified_by', width: 30 },
            { header: 'Final Approval By', key: 'finalApproval_by', width: 20 },
            { header: 'Pending Files Count', key: 'pending', width: 20 },
            { header: 'Closed Files Count', key: 'closed', width: 20 },
            { header: 'Total Files Count', key: 'total', width: 20 },
            { header: 'SOP Total Count', key: 'sop_total', width: 20 },
            { header: 'SOP Not Related Count', key: 'sop_notreleated', width: 20 },
            { header: 'SOP Pending Count', key: 'sop_pending', width: 20 },
            { header: 'SOP Complete Count', key: 'sop_complete', width: 20 },
            { header: 'LOD Total Count', key: 'lod_total', width: 20 },
            { header: 'LOD Not Related Count', key: 'lod_notreleated', width: 20 },
            { header: 'LOD Pending Count', key: 'lod_pending', width: 20 },
            { header: 'LOD Complete Count', key: 'lod_complete', width: 20 },
            { header: 'Address as per Schedule of Property', key: 'address', width: 120 },
            { header: 'Survey Number', key: 'surveyNo', width: 60 },
            { header: 'Door Number', key: 'doorNo', width: 60 },
            { header: 'Property Address – Given by Bank', key: 'propertyAddress', width: 120 },

            { header: 'Bill Type', key: 'bill_type', width: 24 },
            { header: 'Single Bill/ Merge Bill Details', key: 'lh_branch_bill', width: 32 },
            { header: 'Fees Type', key: 'fees_type', width: 20 },
            { header: 'Login Fees', key: 'login_fees', width: 16 },
            { header: 'Existing File Vetting Fees', key: 'existing_file_vetting_fees', width: 24 },
            { header: 'Bill Receive Person TO Email ID', key: 'bill_receive_to_mail', width: 32 },
            { header: 'Bill Receive Person CC Email ID', key: 'cc_mail', width: 32 },
            { header: 'Ec Service Charge', key: 'ec_service_charge', width: 18 },
            { header: 'Cc Service Charge', key: 'cc_service_charge', width: 18 },
            { header: 'Mutation Service Charge', key: 'mutation', width: 22 },

            { header: 'Query Raised Date', key: 'query_raised_dt', width: 20 },
            { header: 'Query Received Date', key: 'query_received_dt', width: 20 },
            { header: 'Typing Completed Date', key: 'typing_completed_dt', width: 20 },
            { header: 'Verification Picked Date', key: 'verification_picked_dt', width: 20 },
            { header: 'Verification Completed Date', key: 'verification_completed_dt', width: 20 },
            { header: 'Double Verification Picked Date', key: 'dverification_picked_dt', width: 20 },
            { header: 'Double Verification Completed Date', key: 'dverification_completed_dt', width: 20 },
            { header: 'Final Approval Picked Date', key: 'final_approval_picked_dt', width: 20 },
            { header: 'Final Approval Completed Date', key: 'final_approval_completed_dt', width: 20 },
            { header: 'Sign Complete Date', key: 'sign_completed_dt', width: 20 },
            { header: 'Sign Complete By', key: 'sign_by', width: 30 },
            { header: 'Report Send To Bank Date and Time', key: 'report_send_to_bank_dt', width: 32 },
            { header: 'Hold By', key: 'hold_by', width: 20 },
            { header: 'Hold Date', key: 'hold_dt', width: 20 },
            { header: 'Hold Reason', key: 'hold_reason', width: 30 },
            { header: 'Unhold By', key: 'unhold_by', width: 20 },
            { header: 'Unhold Date', key: 'unhold_dt', width: 20 },
            { header: 'Unhold Reason', key: 'unhold_reason', width: 30 },
            { header: 'Login Detail Edit Reason', key: 'edit_reason', width: 60 },
            { header: 'Login Detail Edit By', key: 'edit_by', width: 20 },
            { header: 'Login Detail Edit At', key: 'edited_at', width: 20 },
        ];

        // Apply alignment and color to header cells
        worksheet.getRow(1).eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFFF00' }, // Yellow color
            };
            cell.font = { bold: true, size: 14 };
        });

        const flattenedData = data.map((report, index) => {
            return {
                serial: index + 1,
                // id: report.id,
                file_name: report.file_name ? report.file_name : "",
                lh_branch_name: report.lh_branch_name ? report.lh_branch_name : "",
                bank_name: report.bank_name,
                product: report.product,
                bank_branch_name: report.bank_branch_name ? report.bank_branch_name : "",
                borrower_name: report.borrower_name ? report.borrower_name : "",
                owner_name: report.owner_name ? report.owner_name : "",
                app_id: report.app_id ? report.app_id : "",
                file_status: report.file_status ? report.file_status : "",
                login_date: report.login_date ? parseCustomDate(report.login_date) : null,
                updated_dt: report.updated_dt ? parseCustomDate(report.updated_dt) : null,
                prosses_officer: report.prosses_officer ? report.prosses_officer : "",
                verified_by: report.verified_by ? report.verified_by : "",
                finalApproval_by: report.finalApproval_by ? report.finalApproval_by : "",
                pending: report.pending ? report.pending : "",
                closed: report.closed ? report.closed : "",
                total: report.total ? report.total : "",
                sop_total: report.sop_total ? report.sop_total : "0",
                sop_notreleated: report.sop_notreleated ? report.sop_notreleated : "0",
                sop_pending: report.sop_pending ? report.sop_pending : "0",
                sop_complete: report.sop_complete ? report.sop_complete : "0",
                lod_total: report.lod_total ? report.lod_total : "0",
                lod_notreleated: report.lod_notreleated ? report.lod_notreleated : "0",
                lod_pending: report.lod_pending ? report.lod_pending : "0",
                lod_complete: report.lod_complete ? report.lod_complete : "0",
                query_raised_dt: report.query_raised_dt ? parseCustomDate(report.query_raised_dt) : "",
                query_received_dt: report.query_received_dt ? parseCustomDate(report.query_received_dt) : "",
                typing_completed_dt: report.typing_completed_dt ? parseCustomDate(report.typing_completed_dt) : "",
                verification_picked_dt: report.verification_picked_dt ? parseCustomDate(report.verification_picked_dt) : "",
                verification_completed_dt: report.verification_completed_dt ? parseCustomDate(report.verification_completed_dt) : "",
                final_approval_picked_dt: report.final_approval_picked_dt ? parseCustomDate(report.final_approval_picked_dt) : "",
                final_approval_completed_dt: report.final_approval_completed_dt ? parseCustomDate(report.final_approval_completed_dt) : "",
                hold_by: report.hold_by ? report.hold_by : "",
                hold_dt: report.hold_dt ? parseCustomDate(report.hold_dt) : "",
                hold_reason: report.hold_reason ? report.hold_reason : "",
                unhold_by: report.unhold_by ? report.unhold_by : "",
                unhold_dt: report.unhold_dt ? parseCustomDate(report.unhold_dt) : "",
                unhold_reason: report.unhold_reason ? report.unhold_reason : "",
                address: report.address,
                sign_completed_dt: report.sign_completed_dt ? parseCustomDate(report.sign_completed_dt) : null,
                sign_by: report.sign_by ? report.sign_by : "",
                report_send_to_bank_dt: report.report_send_to_bank_dt
                    ? parseCustomDate(report.report_send_to_bank_dt)
                    : "",
                mail_initiate_type: String(
                    report.file_initiation_type ?? report.mail_initiate_type ?? "",
                ),
                file_initiation_received_dt: report.file_initiation_received_dt
                    ? parseCustomDate(report.file_initiation_received_dt)
                    : "",
                mail_query_received_dt: report.mail_query_received_dt
                    ? parseCustomDate(report.mail_query_received_dt)
                    : "",
                dverification_picked_dt: report.dverification_picked_dt ? parseCustomDate(report.dverification_picked_dt) : "",
                dverification_completed_dt: report.dverification_completed_dt ? parseCustomDate(report.dverification_completed_dt) : "",
                dverified_by: report.dverified_by ? report.dverified_by : "",
                loan_type: report.loan_type ? report.loan_type : "",
                surveyNo: report.surveyNo ? report.surveyNo : "",
                doorNo: report.doorNo ? report.doorNo : "",
                propertyAddress: report.propertyAddress ? report.propertyAddress : "",
                bill_type: report.bill_type ? report.bill_type : "",
                lh_branch_bill: report.lh_branch_bill ? report.lh_branch_bill : "",
                fees_type: report.fees_type ? report.fees_type : "",
                login_fees: report.login_fees ? report.login_fees : "",
                existing_file_vetting_fees: report.existing_file_vetting_fees ? report.existing_file_vetting_fees : "",
                bill_receive_to_mail: report.bill_receive_to_mail ? report.bill_receive_to_mail : "",
                cc_mail: report.cc_mail ? report.cc_mail : "",
                ec_service_charge: report.ec_service_charge ? report.ec_service_charge : "",
                cc_service_charge: report.cc_service_charge ? report.cc_service_charge : "",
                mutation: report.mutation ? report.mutation : "",
                edit_reason: formatEditHistory(report.edit_history, "edit_reason", report.edit_reason),
                edit_by: formatEditHistory(report.edit_history, "created_by", report.created_by),
                edited_at: formatEditHistory(report.edit_history, "created_dt", report.created_dt),
            };
        });
        flattenedData.forEach((item) => {
            const row = worksheet.addRow(item);
            row.eachCell((cell, colNumber) => {
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
                if ([1, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31].includes(colNumber)) {
                    cell.numFmt = '0'; // Integer format
                } else if ([5, 32, 35, 41, 42, 64, 65].includes(colNumber)) {
                    cell.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };
                } else if (
                    [13, 14, 15, 16, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 57, 59, 62, 66].includes(colNumber)
                ) {
                    cell.numFmt = 'dd-mm-yyyy hh:mm:ss'; // For date & time format
                }
            });
        });
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate().toString().padStart(2, '0')}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getFullYear()}`;
        // Generate Excel file buffer
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = `Subreport ${formattedDate}.xlsx`;
        anchor.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <>
            <button className="excel-download-btn" onClick={exportExcelFile}>
                Download as Excel
            </button>
        </>
    );
};

export default ExcelSubReport;
